import React from "react";

import { JobAdBox, LoadingIndicator } from "components";
import Constants from "app_constants";
import Theme from "./theme";

const SearchResultsView = ({ jobs, loaded, value }) => {
  return (
    <Theme>
      {Constants.metaTag}
      {loaded ? (
        <>
          {jobs.length !== 0 && (
            <h3 className="searchResults title is-3">{`Search results for "${value}"`}</h3>
          )}

          <div className="columns is-multiline">
            {jobs.map(
              (jobAd, index) =>
                jobAd.published && (
                  <div className="column is-full" key={index.toString()}>
                    <JobAdBox jobAd={jobAd} index={index} />
                  </div>
                )
            )}
          </div>

          {jobs.length === 0 && (
            <p className="warning">
              <b>There isn't any result to show :(</b>
            </p>
          )}
        </>
      ) : (
        <LoadingIndicator />
      )}
    </Theme>
  );
};

export default SearchResultsView;
